<div class="ruckit-truck-reference-cell">
  <truck-reference-selector
    #truckReferences
    (referenceSelected)="onReferenceClicked($event)"
    (onClose)="onReferenceClosed()"
  ></truck-reference-selector>
</div>
